export default {
  actions:{
    buy:'Buy',
    cancel:'Cancel',
    book:'Book',
    reserve: 'Reserve',
    download: 'Download'
  },
  label:{
    price:'Price',
    afterDiscount:'After Discount',
    color:'Color',
    qty:'Quantity',
    desc:'Description',
    speci:'Specifications',
    video:'Watch full video',
    readmore:'Show more',
    showless:'Show Less',
    choose:'Choose from below:',
    submit:'Submit',
    deliverTime:'Choose delivery time',
    selectArea:'Select Area',
    selectCity:'Select City',
    select:'Select'

  },
  images:{
    noImages:'No Images'
  },
  tableLabels:{
    en: [
      {
        key: "name",
        label: "Specifications"
      },
      {
        key: "value",
        label: ""
      }
    ],
  },
  orderCart: {
    label: "Edit Order",
    remove: "Remove",
    increase: "+",
    decrease: "-",
    addProduct: "Add item",
    confirm: "Check Out ",
    cancel:"Close",
    subtotal: "Sub total",
    tax: "Tax",
    delivery: "Delivery fees",
    total: "Total ",
    discount: "Dicount",
    note: "Notes:",
    empty_order: "Your order cart is empty!",
    zero: 0.00,
    edit:'Edit',
    delete:'Delete',
    noItem:'0 items in your cart',
    browsing:'Start browsing'
  },
  notify:{
    errorInput:"Something went wrong, Must fill all fields",
    confirmErr:"Something went wrong, You didn't add anything yet",
    error:"Something went wrong",
    emptyList:"Your order cart is empty!",
    largeFile: "File is too large!",
    maxSize: "Maximum size is",
    support: "file is not supported!",
    uploadError : "File could not be uploaded for some reason, Please try again.",
    multiFilesUpload: "Can't upload more ",
    multiFiles: " files at a time!",
    noInternet : "No internet connection, please try again!"
  },
  placeHolder:{
    input:"Enter ",
    messageInput: "Type a message ..."
  },
  captureLead:{
    phoneValidation:'Invalid phone number',
    emailValidation: 'Invalid email',
    hello: "Hello there!"
  },
  footer: { 
    poweredBy: "Powered by"
  },
  chatBody: {
    typingIndicator: "Bot is thinking...",
  },
};
